import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		email: Yup.string()
			.email(t("invalid_format"))
			.required(t("fill_required_fields")),
		password: Yup.string().required(t("fill_required_fields")),
	});
};
